import { Box, Button } from '@factorialco/deprecated-design-system'
import { ApproveCardDocument, ApproveCardMutation } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { canApproveCard } from 'modules/banking/lib/cards/canApproveCard'
import { BankingCard } from 'modules/banking/lib/cards/types'

interface ModalProps {
  card: BankingCard
  onClose: () => void
  onSuccess?: () => void
}

export const ApproveModal = ({ card, onClose, onSuccess }: ModalProps) => {
  const [approveCard, { loading }] = useMutation(ApproveCardDocument, {
    extractorFn: (data: ApproveCardMutation) => data.bankingMutations.approveBankingCard,
  })

  const companyId = useCurrentSession().company.id

  const handleSubmit = async () => {
    const res = await approveCard({
      variables: {
        cardId: card.id + '',
        companyId: companyId,
      },
    })
    const result = handleResult(res, (errors) => {
      app.setFlash({
        type: 'wrong',
        message: errors['messages'] || i18n.t('errors.generic_error'),
      })
    })

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('expenses_v2.cards.actions.modal.approve.success'),
      })

      onSuccess?.()
    }

    onClose()
  }

  return (
    <Modal
      title={i18n.t('expenses_v2.cards.actions.modal.approve.title')}
      description={i18n.t('expenses_v2.cards.actions.modal.approve.description')}
      illustration="alert"
      onSubmit={handleSubmit}
      onClose={onClose}
      footer={
        <Box flexDirection="row" gap="s16">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit disabled={loading || !canApproveCard(card)}>
            {i18n.t('expenses_v2.cards.actions.modal.approve.text')}
          </Button>
        </Box>
      }
    ></Modal>
  )
}
